var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('div',{staticClass:"home"},[_c('p',[_vm._v("Herzlich willkommen auf unserem Adminserver!")]),_c('p',[_vm._v("Bitte wählen Sie ein Modul aus der oberen Menüleiste.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }